import SchoolSummaryApiClient from "api/SchoolSummaryApiClient";
import { useBuildReport } from "hooks/reports/useBuildReport";
import { ReportFormat } from "api/Enums";

export function useGenerateSchoolSummary(options) {
    return useBuildReport(
        (schoolId) => SchoolSummaryApiClient.buildSchoolSummary(schoolId, ReportFormat.Json),
        options,
    );
}
